export function getColorsWithAlpha(alpha) {
  let colorArrayWithAlpha = [];
  
  for(let baseColor of baseColorArray) {
    let colorWithAlpha = `rgba(${baseColor}, ${alpha})`;
    
    colorArrayWithAlpha.push(colorWithAlpha)
  }
  
  return colorArrayWithAlpha;
}

export const ALPHA_FOR_BORDER = 1;
export const ALPHA_FOR_OFFICIAL_CERTIFICATES = 0.9;
export const ALPHA_FOR_LIVE_CERTIFICATES = 0.5;

// const baseColorArray = [
//   "0, 170, 255",
//   "85, 35, 130",
//   "230, 46, 135",
//   "0, 95, 170",
//   "0, 135, 56",
//   "104, 175, 35",
//   "190, 205, 0",
//   "226, 0, 26",
//   "255, 195, 0",
//   "73, 95, 118",
//   "223, 238, 103",
//   "239, 104, 111",
//   "103, 139, 107",
//   "78, 132, 184",
//   "164, 25, 93",
//   "189, 160, 247",
//   "5, 32, 71",
//   "163, 111, 90",
//   "228, 72, 74",
//   "255, 115, 28",
//   "86, 64, 8",
//   "255, 248, 226",
//   "76, 251, 134",
//   "9, 160, 170",
//   "200, 130, 7"

// ];

const baseColorArray = [
  "0, 170, 255",    // Blue
  "85, 35, 130",    // Purple
  "230, 46, 135",   // Pink
  "0, 95, 170",     // Navy Blue
  "0, 135, 56",     // Green
  "104, 175, 35",   // Lime Green
  "190, 205, 0",    // Yellow Green
  "226, 0, 26",     // Red
  "255, 195, 0",    // Yellow
  "73, 95, 118",    // Grayish Blue
  "223, 238, 103",  // Pale Green
  "239, 104, 111",  // Salmon
  "103, 139, 107",  // Olive Green
  "78, 132, 184",   // Sky Blue
  "164, 25, 93",    // Dark Magenta
  "189, 160, 247",  // Lavender
  "5, 32, 71",      // Dark Blue
  "163, 111, 90",   // Brown
  "228, 72, 74",    // Coral
  "255, 115, 28",   // Orange
  "47, 79, 79",     // Slate Gray
  "255, 140, 0",    // Dark Orange
  "138, 43, 226",   // Blue Violet
  "0, 128, 128",    // Teal
  "255, 0, 127",    // Magenta
  "160, 82, 45",    // Sienna
  "0, 206, 209",    // Dark Turquoise
  "255, 69, 0",     // Red-Orange
  "128, 0, 0",      // Maroon
  "255, 20, 147",   // Deep Pink
  "128, 128, 0",    // Olive
  "70, 130, 180",   // Steel Blue
  "255, 99, 71",    // Tomato
  "34, 139, 34",    // Forest Green
  "255, 160, 122",  // Light Salmon
  "75, 0, 130",     // Indigo
  "255, 223, 186",  // Navajo White
  "0, 255, 255"     // Cyan
];





// WEBPACK FOOTER //
// ./src/constants/Colors.js